import Vue from "vue";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import {
  faTimesCircle,
  faCalculator,
  faChevronLeft,
} from "@fortawesome/free-solid-svg-icons";

library.add(faTimesCircle, faCalculator, faChevronLeft);

Vue.component("font-awesome-icon", FontAwesomeIcon);
